import {
  computePosition,
  flip,
  shift,
  offset,
  hide,
  arrow,
} from "@floating-ui/dom";

function initMenuTooltip() {
  // Select all submenu holders and initialize timeout for hover delays
  let submenuHolders = document.querySelectorAll("#main-nav li.has-submenu");
  let activeTimeout = null; // ← globale Timeout-ID
  let activeTooltip = null; // ← Referenz auf gerade offenes Submenü

  // Hilfsfunktion: schließt ALLE Submenüs sofort
  function closeAllTooltips() {
    submenuHolders.forEach((holder) => {
      const tooltip = holder.querySelector(".submenu");
      const link = holder.querySelector("a");
      if (tooltip) {
        tooltip.classList.remove("open");
        tooltip.setAttribute("style", "");
      }
      if (link) link.setAttribute("aria-expanded", "false");
    });
    clearTimeout(activeTimeout);
    activeTimeout = null;
    activeTooltip = null;
  }

  // Select arrows, menu links, submenu links, and home logo for styling and accessibility
  const submenuArrow = document.querySelectorAll(
    "header nav .has-submenu > .arrow",
  );
  const menulinks = document.querySelectorAll("header nav > ul > li");
  const menusublinks = document.querySelectorAll(
    "header nav li.has-submenu ul > li",
  );
  console.log(menusublinks);
  const menuHomeLogo = document.querySelector(".site-branding__logo");

  // Mark active menu links based on current URL
  menulinks.forEach((link) => {
    if (window.location.href == link.firstElementChild.href) {
      link.classList.add("active");
      console.log("active item", link.closest(".primary-item"));
      link.firstElementChild.setAttribute("aria-current", "page");
    }
  });

  // Mark active submenu links and remove aria-current from parent links
  menusublinks.forEach((link) => {
    if (link.firstElementChild.href === window.location.href) {
      link.classList.add("active");
      link.firstElementChild.setAttribute("aria-current", "page");
      link.closest(".primary-item").classList.add("primary-active");

      // Nur den direkten Parent-Link bereinigen, nicht ALLE
      const parentLi = link.closest(".primary-item");
      if (parentLi) {
        const parentLink = parentLi.querySelector(":scope > a");
        if (parentLink) parentLink.removeAttribute("aria-current");
      }
    }
  });

  // Mark home logo as active if current URL matches
  if (window.location.href.includes(menuHomeLogo.href))
    menuHomeLogo.setAttribute("aria-current", "page");

  submenuHolders.forEach((submenuHolder, index) => {
    // Get references to the button, tooltip, and arrow elements
    const button = submenuHolder;
    const tooltip = submenuHolder.querySelector(".submenu");
    const label = submenuHolder.dataset.tooltip || tooltip.id.split("_")?.at(1);
    const arrowEl = tooltip.querySelector(".nav__arrow");
    // console.log("arrowEl", arrowEl);
    console.log("submenuHolders init", button, label, tooltip);

    // Update tooltip position using Floating UI
    function updateTooltip() {
      if (window.innerWidth >= 768) {
        computePosition(button, tooltip, {
          // Position tooltip to the right on smaller screens, bottom on larger screens
          placement: window.innerWidth < 1024 ? "right" : "bottom",
          middleware: [
            flip(),
            shift({ padding: 20 }),
            offset(10),
            arrow({ element: arrowEl }),
          ],
        }).then(({ x, y, middlewareData }) => {
          // Apply calculated position to the tooltip
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          });
          // Position the arrow if middleware data is available
          if (middlewareData.arrow) {
            const mwa = middlewareData.arrow;
            Object.assign(arrowEl.style, {
              left: mwa.x != null ? `${mwa.x}px` : "",
              top: mwa.y != null ? `${mwa.y}px` : "",
            });
          }
        });
      }
    }

    // Show tooltip on hover or click
    function showTooltip(e) {
      // e.preventDefault();

      // Handle mouse clicks
      if (e.pointerType === "mouse") {
        // e.currentTarget.querySelector("a").click();
        // e.currentTarget.classList.toggle("hover");
      }

      // Function to display the tooltip
      const fire = (e) => {
        // Zuerst alle anderen sofort schließen
        closeAllTooltips();
        tooltip.classList.add("open");
        activeTooltip = tooltip;
        console.log("showTooltip.2 fire", e, e.currentTarget, tooltip);
        console.log("tooltip.classList", tooltip, tooltip.classList);

        // AI
        const link = button.querySelector("a");
        if (link) link.setAttribute("aria-expanded", "true");

        clearTimeout(timeout);
        console.log("cleared timeout:", timeout);
        console.log("updating Tooltip");
        if (window.innerWidth >= 767.9) {
          updateTooltip();
        }
        console.log("tooltip.classList", tooltip, tooltip.classList);
      };
      console.log(
        "showTooltip.1 init",
        e,
        e.type,
        e.key,
        e.pointerType,
        !e.type.includes("mouse") || e.pointerType !== "mouse",
      );
      // Handle non-mouse interactions (e.g., keyboard)
      if (
        (e.pointerType !== "mouse" && e.pointerType != undefined) ||
        !e.type.includes("mouse")
      ) {
        console.log("not a mouse:", e.pointerType);
        const toggleLink = e.currentTarget.querySelector("a");
        if (toggleLink && toggleLink.getAttribute("aria-expanded") === "true") {
          hideTooltip();
          // Hide tooltip if already expanded
          // if (e.currentTarget.getAttribute("aria-expanded") === "true") {
          //     console.log("showTooltop. expanded already", e.currentTarget);
          //     // hideTooltip();
          //     // return false;
          // }
        } else {
          fire(e);
        }
        //   e.currentTarget.setAttribute("aria-expanded", "true");
      } else {
        // Handle mouse hover
        if (window.innerWidth >= 768 && e.type === "mouseenter") fire(e);
      }
    }

    // Hide tooltip with optional delay
    function hideTooltip(immidiate = false) {
      // Check if the mouse is not over the submenu itself
      console.log("hideTooltip.1.1", tooltip, this);
      console.log("hideTooltip.1.2", immidiate);
      console.log("hideTooltip.1.3 immidiate", typeof immidiate);

      // AI
      if (activeTooltip !== tooltip) return;

      // Delayed hide for hover-out events
      if (typeof immidiate === "object") {
        if (window.innerWidth < 768) return;
        activeTimeout = setTimeout(() => {
          if (!tooltip.matches(":hover")) {
            tooltip.classList.remove("open");
            tooltip.setAttribute("style", "");
            const link = button.querySelector("a");
            if (link) link.setAttribute("aria-expanded", "false");
            activeTooltip = null;
          }
        }, 200);
      } else {
        // Immediate hide
        console.log("hideTooltip.4", tooltip, tooltip.matches(":hover"));
        tooltip.classList.remove("open");
        tooltip.setAttribute("style", "");
        const link = button.querySelector("a");
        if (link) link.setAttribute("aria-expanded", "false");
        activeTooltip = null;
        console.log("hideTooltip.5", tooltip, tooltip.style.display);
      }
      // tooltip.style.display = "";
      //         console.log("hideTooltip.6, target ->", target);

      // Before AI
      // tooltip.parentElement.setAttribute("aria-expanded", "false");
      // After AI
      // Aria-expanded auf dem LINK (innerhalb von button = li) zurücksetzen
      const link = button.querySelector("a");
      if (link) link.setAttribute("aria-expanded", "false");
    }

    // Show/hide via mouse hover (Desktop)
    button.addEventListener("mouseenter", showTooltip);
    button.addEventListener("mouseleave", hideTooltip);

    // Show/hide via click (Touch & Tastatur)
    button.addEventListener("click", showTooltip);

    // Show when focus moves INTO the submenu item (prevents focus trap)
    button.addEventListener("focusin", function (e) {
      const link = button.querySelector("a");
      // Nur öffnen wenn noch nicht offen
      if (link && link.getAttribute("aria-expanded") !== "true") {
        showTooltip(e);
      }
    });

    // Hide when focus moves OUT of submenu tree
    button.addEventListener("focusout", function (e) {
      // Check if new focus target is still inside this menu item
      const newFocus = e.relatedTarget;
      if (!button.contains(newFocus) && !tooltip.contains(newFocus)) {
        hideTooltip(true);
      }
    });

    // Clear timeout when mouse enters tooltip to prevent flickering
    tooltip.addEventListener("mouseenter", () => {
      console.log("in Tooltip");
      clearTimeout(timeout);
    });
    // Hide tooltip when mouse leaves it
    // tooltip.addEventListener("mouseleave", () => {
    //   console.log("out of Tooltip");
    //   hideTooltip(true);
    // });
  });

  // AI, ESC-Taste schließt alle Submenüs
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      submenuHolders.forEach((sh) => {
        const t = sh.querySelector(".submenu");
        if (t && t.classList.contains("open")) {
          t.classList.remove("open");
          t.setAttribute("style", "");
          const link = sh.querySelector("a");
          if (link) link.setAttribute("aria-expanded", "false");
        }
      });
    }
  });
}

function initMenuToggle() {
  // Toggle Menu Icon

  // Get references to menu elements
  let mainId = "hamburger-icon",
    $navicon = document.getElementById(mainId),
    $icon = document.getElementById(mainId + "__icon"),
    $header = document.getElementsByTagName("header")[0],
    $hauptmenu = document.getElementById("main-nav");

  $navicon.setAttribute("tabindex", "0");

  console.log("$icon", $icon);
  // Toggle Menu Icon and Header on click
  $navicon.addEventListener("click", function (e) {
    e.preventDefault();
    const isOpen = $header.classList.toggle("open");
    $icon.classList.toggle("open", isOpen);
    this.setAttribute("aria-expanded", isOpen);

    if (isOpen) {
      // Fokus auf ersten Menü-Link verschieben
      const firstLink = $hauptmenu.querySelector("a");
      if (firstLink) firstLink.focus();
    } else {
      // Bei Schließen: Fokus zurück auf Hamburger
      $navicon.focus();
    }
  });

  // Toggle Menu
  // AI, Touch/Click auf Submenü-Links in Mobile
  $hauptmenu.querySelectorAll(".has-submenu").forEach((e) => {
    const link = e.querySelector("a");
    if (!link) return;

    link.addEventListener("click", function (event) {
      if (window.innerWidth <= 768) {
        const submenu = e.querySelector(".submenu");
        const isExpanded = link.getAttribute("aria-expanded") === "true";

        if (submenu) {
          event.preventDefault();
          submenu.classList.toggle("open", !isExpanded);
          link.setAttribute("aria-expanded", !isExpanded);
        }
      }
    });
  });

  // AI, ESC-Taste schließt mobiles Menü
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && $header.classList.contains("open")) {
      $icon.classList.remove("open");
      $header.classList.remove("open");
      $navicon.setAttribute("aria-expanded", "false");
      $navicon.focus(); // Fokus zurück auf Hamburger
    }
  });
}

function makeMenubarSticky() {
  // Menubar gets sticky
  // Observe intersection to toggle 'scrolled' class on header
  const observer = new IntersectionObserver(
    ([e]) => {
      console.log("intersection", e.intersectionRatio);
      // Toggle 'scrolled' class when header is no longer fully visible
      return e.target.classList.toggle("scrolled", e.intersectionRatio < 1);
    },
    {
      threshold: [1],
    },
  );
}
let menu;

export default menu = {
  toggle: initMenuToggle,
  tooltip: initMenuTooltip,
};
